__webpack_public_path__ = window.shop_productgroup.resource_base_url || '';